import React from 'react';
import { Text, Container } from 'basis';
import { CrbConsent } from './CrbConsent';
import { DvsConsent } from './DvsConsent';

export const IdvConsents = () => {
  return (
    <div>
      <Text textStyle="heading5">Save time with fast and secure online identity verification</Text>
      <Container padding="3 0">
        <Text>We use safe and reliable checks to verify your identity quickly, so you can proceed without delays.</Text>
      </Container>
      <CrbConsent />
      <DvsConsent />
    </div>
  );
};
